export class CreateConveyanceSegmentConfigRequest {
  ConveyanceSegmentID: number;
  ConfigName: string;
  ConfigValue: string;
}
